// Copyright (c) 2026 Otyka LLC. All rights reserved.

import React from 'react';

export default function TenantLoader() {
  return (
    <div className="app" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <div style={{ textAlign: 'center', color: 'var(--gray-400)' }}>
        <div style={{
          width: 40, height: 40, margin: '0 auto 16px',
          border: '3px solid var(--gray-200)', borderTopColor: 'var(--green-light)',
          borderRadius: '50%', animation: 'spin 0.8s linear infinite',
        }} />
        <p>Loading…</p>
      </div>
    </div>
  );
}
